import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Country  {
    _originalTypeClassName = "zERP.BO.Country";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Country.translate = translateService;
}
this.Id = null;
this.Name = null;
this.TwoLetterCode = null;
this.EnglishName = null;
this.Nationality = null;
this.Citizenship = null;
this.Code = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
TwoLetterCode:any;
EnglishName:any;
Nationality:any;
Citizenship:any;
Code:any;

static GetClassName(): any{return "Country";
}
static ToCountryType($this: any): any{switch ($this?.TwoLetterCode) {case "AD":
{
return Domain.CountryType.AD;}
case "AE":
{
return Domain.CountryType.AE;}
case "AF":
{
return Domain.CountryType.AF;}
case "AG":
{
return Domain.CountryType.AG;}
case "AI":
{
return Domain.CountryType.AI;}
case "AL":
{
return Domain.CountryType.AL;}
case "AM":
{
return Domain.CountryType.AM;}
case "AN":
{
return Domain.CountryType.AN;}
case "AO":
{
return Domain.CountryType.AO;}
case "AQ":
{
return Domain.CountryType.AQ;}
case "AR":
{
return Domain.CountryType.AR;}
case "AS":
{
return Domain.CountryType.AS;}
case "AT":
{
return Domain.CountryType.AT;}
case "AU":
{
return Domain.CountryType.AU;}
case "AW":
{
return Domain.CountryType.AW;}
case "AX":
{
return Domain.CountryType.AX;}
case "AZ":
{
return Domain.CountryType.AZ;}
case "BA":
{
return Domain.CountryType.BA;}
case "BB":
{
return Domain.CountryType.BB;}
case "BD":
{
return Domain.CountryType.BD;}
case "BE":
{
return Domain.CountryType.BE;}
case "BF":
{
return Domain.CountryType.BF;}
case "BG":
{
return Domain.CountryType.BG;}
case "BH":
{
return Domain.CountryType.BH;}
case "BI":
{
return Domain.CountryType.BI;}
case "BJ":
{
return Domain.CountryType.BJ;}
case "BL":
{
return Domain.CountryType.BL;}
case "BM":
{
return Domain.CountryType.BM;}
case "BN":
{
return Domain.CountryType.BN;}
case "BO":
{
return Domain.CountryType.BO;}
case "BR":
{
return Domain.CountryType.BR;}
case "BS":
{
return Domain.CountryType.BS;}
case "BT":
{
return Domain.CountryType.BT;}
case "BV":
{
return Domain.CountryType.BV;}
case "BW":
{
return Domain.CountryType.BW;}
case "BY":
{
return Domain.CountryType.BY;}
case "BZ":
{
return Domain.CountryType.BZ;}
case "CA":
{
return Domain.CountryType.CA;}
case "CC":
{
return Domain.CountryType.CC;}
case "CD":
{
return Domain.CountryType.CD;}
case "CF":
{
return Domain.CountryType.CF;}
case "CG":
{
return Domain.CountryType.CG;}
case "CH":
{
return Domain.CountryType.CH;}
case "CI":
{
return Domain.CountryType.CI;}
case "CK":
{
return Domain.CountryType.CK;}
case "CL":
{
return Domain.CountryType.CL;}
case "CM":
{
return Domain.CountryType.CM;}
case "CN":
{
return Domain.CountryType.CN;}
case "CO":
{
return Domain.CountryType.CO;}
case "CR":
{
return Domain.CountryType.CR;}
case "CU":
{
return Domain.CountryType.CU;}
case "CV":
{
return Domain.CountryType.CV;}
case "CX":
{
return Domain.CountryType.CX;}
case "CY":
{
return Domain.CountryType.CY;}
case "CZ":
{
return Domain.CountryType.CZ;}
case "DE":
{
return Domain.CountryType.DE;}
case "DJ":
{
return Domain.CountryType.DJ;}
case "DK":
{
return Domain.CountryType.DK;}
case "DM":
{
return Domain.CountryType.DM;}
case "DO":
{
return Domain.CountryType.DO;}
case "DZ":
{
return Domain.CountryType.DZ;}
case "EC":
{
return Domain.CountryType.EC;}
case "EE":
{
return Domain.CountryType.EE;}
case "EG":
{
return Domain.CountryType.EG;}
case "EH":
{
return Domain.CountryType.EH;}
case "ER":
{
return Domain.CountryType.ER;}
case "ES":
{
return Domain.CountryType.ES;}
case "ET":
{
return Domain.CountryType.ET;}
case "FI":
{
return Domain.CountryType.FI;}
case "FJ":
{
return Domain.CountryType.FJ;}
case "FK":
{
return Domain.CountryType.FK;}
case "FM":
{
return Domain.CountryType.FM;}
case "FO":
{
return Domain.CountryType.FO;}
case "FR":
{
return Domain.CountryType.FR;}
case "GA":
{
return Domain.CountryType.GA;}
case "GB":
{
return Domain.CountryType.GB;}
case "GD":
{
return Domain.CountryType.GD;}
case "GE":
{
return Domain.CountryType.GE;}
case "GF":
{
return Domain.CountryType.GF;}
case "GG":
{
return Domain.CountryType.GG;}
case "GH":
{
return Domain.CountryType.GH;}
case "GI":
{
return Domain.CountryType.GI;}
case "GL":
{
return Domain.CountryType.GL;}
case "GM":
{
return Domain.CountryType.GM;}
case "GN":
{
return Domain.CountryType.GN;}
case "GP":
{
return Domain.CountryType.GP;}
case "GQ":
{
return Domain.CountryType.GQ;}
case "GR":
{
return Domain.CountryType.GR;}
case "GS":
{
return Domain.CountryType.GS;}
case "GT":
{
return Domain.CountryType.GT;}
case "GU":
{
return Domain.CountryType.GU;}
case "GW":
{
return Domain.CountryType.GW;}
case "GY":
{
return Domain.CountryType.GY;}
case "HK":
{
return Domain.CountryType.HK;}
case "HM":
{
return Domain.CountryType.HM;}
case "HN":
{
return Domain.CountryType.HN;}
case "HR":
{
return Domain.CountryType.HR;}
case "HT":
{
return Domain.CountryType.HT;}
case "HU":
{
return Domain.CountryType.HU;}
case "ID":
{
return Domain.CountryType.ID;}
case "IE":
{
return Domain.CountryType.IE;}
case "IL":
{
return Domain.CountryType.IL;}
case "IM":
{
return Domain.CountryType.IM;}
case "IN":
{
return Domain.CountryType.IN;}
case "IO":
{
return Domain.CountryType.IO;}
case "IQ":
{
return Domain.CountryType.IQ;}
case "IR":
{
return Domain.CountryType.IR;}
case "IS":
{
return Domain.CountryType.IS;}
case "IT":
{
return Domain.CountryType.IT;}
case "JE":
{
return Domain.CountryType.JE;}
case "JM":
{
return Domain.CountryType.JM;}
case "JO":
{
return Domain.CountryType.JO;}
case "JP":
{
return Domain.CountryType.JP;}
case "KE":
{
return Domain.CountryType.KE;}
case "KG":
{
return Domain.CountryType.KG;}
case "KH":
{
return Domain.CountryType.KH;}
case "KI":
{
return Domain.CountryType.KI;}
case "KM":
{
return Domain.CountryType.KM;}
case "KN":
{
return Domain.CountryType.KN;}
case "KP":
{
return Domain.CountryType.KP;}
case "KR":
{
return Domain.CountryType.KR;}
case "KW":
{
return Domain.CountryType.KW;}
case "KY":
{
return Domain.CountryType.KY;}
case "KZ":
{
return Domain.CountryType.KZ;}
case "LA":
{
return Domain.CountryType.LA;}
case "LB":
{
return Domain.CountryType.LB;}
case "LC":
{
return Domain.CountryType.LC;}
case "LI":
{
return Domain.CountryType.LI;}
case "LK":
{
return Domain.CountryType.LK;}
case "LR":
{
return Domain.CountryType.LR;}
case "LS":
{
return Domain.CountryType.LS;}
case "LT":
{
return Domain.CountryType.LT;}
case "LU":
{
return Domain.CountryType.LU;}
case "LV":
{
return Domain.CountryType.LV;}
case "LY":
{
return Domain.CountryType.LY;}
case "MA":
{
return Domain.CountryType.MA;}
case "MC":
{
return Domain.CountryType.MC;}
case "MD":
{
return Domain.CountryType.MD;}
case "ME":
{
return Domain.CountryType.ME;}
case "MF":
{
return Domain.CountryType.MF;}
case "MG":
{
return Domain.CountryType.MG;}
case "MH":
{
return Domain.CountryType.MH;}
case "MK":
{
return Domain.CountryType.MK;}
case "ML":
{
return Domain.CountryType.ML;}
case "MM":
{
return Domain.CountryType.MM;}
case "MN":
{
return Domain.CountryType.MN;}
case "MO":
{
return Domain.CountryType.MO;}
case "MP":
{
return Domain.CountryType.MP;}
case "MQ":
{
return Domain.CountryType.MQ;}
case "MR":
{
return Domain.CountryType.MR;}
case "MS":
{
return Domain.CountryType.MS;}
case "MT":
{
return Domain.CountryType.MT;}
case "MU":
{
return Domain.CountryType.MU;}
case "MV":
{
return Domain.CountryType.MV;}
case "MW":
{
return Domain.CountryType.MW;}
case "MX":
{
return Domain.CountryType.MX;}
case "MY":
{
return Domain.CountryType.MY;}
case "MZ":
{
return Domain.CountryType.MZ;}
case "NA":
{
return Domain.CountryType.NA;}
case "NC":
{
return Domain.CountryType.NC;}
case "NE":
{
return Domain.CountryType.NE;}
case "NF":
{
return Domain.CountryType.NF;}
case "NG":
{
return Domain.CountryType.NG;}
case "NI":
{
return Domain.CountryType.NI;}
case "NL":
{
return Domain.CountryType.NL;}
case "NO":
{
return Domain.CountryType.NO;}
case "NP":
{
return Domain.CountryType.NP;}
case "NR":
{
return Domain.CountryType.NR;}
case "NU":
{
return Domain.CountryType.NU;}
case "NZ":
{
return Domain.CountryType.NZ;}
case "OM":
{
return Domain.CountryType.OM;}
case "PA":
{
return Domain.CountryType.PA;}
case "PE":
{
return Domain.CountryType.PE;}
case "PF":
{
return Domain.CountryType.PF;}
case "PG":
{
return Domain.CountryType.PG;}
case "PH":
{
return Domain.CountryType.PH;}
case "PK":
{
return Domain.CountryType.PK;}
case "PL":
{
return Domain.CountryType.PL;}
case "PM":
{
return Domain.CountryType.PM;}
case "PN":
{
return Domain.CountryType.PN;}
case "PR":
{
return Domain.CountryType.PR;}
case "PS":
{
return Domain.CountryType.PS;}
case "PT":
{
return Domain.CountryType.PT;}
case "PW":
{
return Domain.CountryType.PW;}
case "PY":
{
return Domain.CountryType.PY;}
case "QA":
{
return Domain.CountryType.QA;}
case "RE":
{
return Domain.CountryType.RE;}
case "RO":
{
return Domain.CountryType.RO;}
case "RS":
{
return Domain.CountryType.RS;}
case "RU":
{
return Domain.CountryType.RU;}
case "RW":
{
return Domain.CountryType.RW;}
case "SA":
{
return Domain.CountryType.SA;}
case "SB":
{
return Domain.CountryType.SB;}
case "SC":
{
return Domain.CountryType.SC;}
case "SD":
{
return Domain.CountryType.SD;}
case "SE":
{
return Domain.CountryType.SE;}
case "SG":
{
return Domain.CountryType.SG;}
case "SH":
{
return Domain.CountryType.SH;}
case "SI":
{
return Domain.CountryType.SI;}
case "SJ":
{
return Domain.CountryType.SJ;}
case "SK":
{
return Domain.CountryType.SK;}
case "SL":
{
return Domain.CountryType.SL;}
case "SM":
{
return Domain.CountryType.SM;}
case "SN":
{
return Domain.CountryType.SN;}
case "SO":
{
return Domain.CountryType.SO;}
case "SR":
{
return Domain.CountryType.SR;}
case "ST":
{
return Domain.CountryType.ST;}
case "SV":
{
return Domain.CountryType.SV;}
case "SY":
{
return Domain.CountryType.SY;}
case "SZ":
{
return Domain.CountryType.SZ;}
case "TC":
{
return Domain.CountryType.TC;}
case "TD":
{
return Domain.CountryType.TD;}
case "TF":
{
return Domain.CountryType.TF;}
case "TG":
{
return Domain.CountryType.TG;}
case "TH":
{
return Domain.CountryType.TH;}
case "TJ":
{
return Domain.CountryType.TJ;}
case "TK":
{
return Domain.CountryType.TK;}
case "TL":
{
return Domain.CountryType.TL;}
case "TM":
{
return Domain.CountryType.TM;}
case "TN":
{
return Domain.CountryType.TN;}
case "TO":
{
return Domain.CountryType.TO;}
case "TR":
{
return Domain.CountryType.TR;}
case "TT":
{
return Domain.CountryType.TT;}
case "TV":
{
return Domain.CountryType.TV;}
case "TW":
{
return Domain.CountryType.TW;}
case "TZ":
{
return Domain.CountryType.TZ;}
case "UA":
{
return Domain.CountryType.UA;}
case "UG":
{
return Domain.CountryType.UG;}
case "UM":
{
return Domain.CountryType.UM;}
case "US":
{
return Domain.CountryType.US;}
case "UY":
{
return Domain.CountryType.UY;}
case "UZ":
{
return Domain.CountryType.UZ;}
case "VA":
{
return Domain.CountryType.VA;}
case "VC":
{
return Domain.CountryType.VC;}
case "VE":
{
return Domain.CountryType.VE;}
case "VG":
{
return Domain.CountryType.VG;}
case "VI":
{
return Domain.CountryType.VI;}
case "VN":
{
return Domain.CountryType.VN;}
case "VU":
{
return Domain.CountryType.VU;}
case "WF":
{
return Domain.CountryType.WF;}
case "WS":
{
return Domain.CountryType.WS;}
case "YE":
{
return Domain.CountryType.YE;}
case "YT":
{
return Domain.CountryType.YT;}
case "ZA":
{
return Domain.CountryType.ZA;}
case "ZM":
{
return Domain.CountryType.ZM;}
case "ZW":
{
return Domain.CountryType.ZW;}
default:
{
return Domain.CountryType.GR;}
}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}